import { DataTable } from "@ventumsoftware/react-toolkit";
import type { FC } from "react";
import { useApi } from "../api/APIContext";
import { ContentContainer } from "../components/content/ContentContainer";
import { PageHeader } from "../components/content/PageHeader";
import { TablePlaceholder } from "../components/data/TablePlaceholder";
import { Loading } from "../components/Loading";

export const QuestionSetsPage: FC<{}> = (props) => {
  const { questionSets, loading } = useApi();
  return (
    <ContentContainer size={"md"}>
      <PageHeader>Vragenlijsten</PageHeader>

      <Loading loading={loading}>
        {questionSets.length === 0 ? (
          <TablePlaceholder>Geen vragenlijsten gevonden</TablePlaceholder>
        ) : (
          <DataTable
            keyProperty={"id"}
            data={questionSets}
            pageSize={50}
            columns={[
              { header: "Name", sort: true, property: "name" },
              {
                header: "Score categorieën",
                property: "scoringPerCategory",
                transform: (value) => Object.keys(value).join(", "),
              },
              {
                header: "Aantal vragen",
                property: "questions",
                transform: (value) => value.length,
              },
            ]}
          />
        )}
      </Loading>
    </ContentContainer>
  );
};
